import React from 'react';

import { Alert } from './Alert';

export function ErrorMessage({ error }) {
  const message = typeof error === 'object' ? JSON.stringify(error) : error;
  return <Alert danger>{message}</Alert>;
}
